import React, { useState } from 'react'
import { Row, Col, Button, Table, Input, Form, Card, CardBody, CardHeader, Collapse } from 'reactstrap'

const GoalAccordion = ({ goals, goalType, onGoalUpdate, onActivityUpdate, onAddActivity, onDeleteGoal, onRemoveActivity }) => {
	const [openAccordion, setOpenAccordion] = useState('0')

	const toggle = (id) => {
		if (openAccordion === id) {
			setOpenAccordion(null)
		} else {
			setOpenAccordion(id)
		}
	}

	const getExamplesList = (type) => {
		const examples = {
			volunteering: [
				'Hospitals / Schools / Libraries',
				'Shelters / Senior Home / Veteran Help',
				'Community Cleaning Project',
				'Weekend School',
				'Event Volunteer',
				'Online Courses / Workshops',
				'Skill Development Programs',
				'Volunteering in Education',
				'Networking Events',
				'Personal Projects'
			],
			personal_development: [
				'Job Shadow / Internship / Employment',
				'College Courses / Online Course / Tutoring',
				'Journalism / Photography / Film Editing',
				'Mental Health',
				'Kur-an Class',
				'Online Courses / Workshops',
				'Skill Development Programs',
				'Volunteering in Education',
				'Networking Events',
				'Personal Projects'
			],
			physical_fitness: [
				'GYM / Daily Exercise',
				'Clubs',
				'Team Practice',
				'Walking / Running',
				'Yoga / Pilates',
				'Martial Arts',
				'Fitness Classes',
				'Sports Teams',
				'Marathons',
				'Outdoor Activities',
				'Health Challenges'
			],
			exploration: [
				'Travel / Discover New Cultures',
				'Outdoor Adventures',
				'Learn a New Language',
				'Attend Workshops',
				'Explore Local History',
				'Cultural Festivals',
				'Outdoor Clubs',
				'Language Exchange Programs',
				'Travel Groups',
				'Workshops and Seminars'
			]
		}
		return examples[type] || []
	}

	return (
		<Row>
			<Col xs={12} md={9}>
				{goals.map((goal, index) => (
					<Card key={index} className="mb-2">
						<CardHeader>
							<div className="d-flex justify-content-between align-items-center">
								<div onClick={() => toggle(index.toString())} style={{ cursor: 'pointer', flex: 1 }} className="d-flex align-items-center">
									<i className={`fa fa-chevron-${openAccordion === index.toString() ? 'down' : 'right'} me-2`}></i>
									<span>
										{goalType.replace('_', ' ').toUpperCase()} #{index + 1}
									</span>
								</div>
								<Button color="danger" size="sm" onClick={() => onDeleteGoal(goalType, index)}>
									Delete Goal
								</Button>
							</div>
						</CardHeader>
						<Collapse isOpen={openAccordion === index.toString()}>
							<CardBody>
								<Form>
									<Table bordered>
										<tbody>
											<tr>
												<td colSpan={3}>
													<Row className="d-flex align-items-center">
														<Col xs={12} md={3}>
															<h6>What is your goal?</h6>
														</Col>
														<Col xs={12} md={9}>
															<Input
																type="textarea"
																rows={3}
																value={goal.goaldesc || ''}
																onChange={(e) => onGoalUpdate(goalType, index, 'goaldesc', e.target.value)}
															/>
														</Col>
													</Row>
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<Row className="d-flex align-items-center">
														<Col xs={12} md={3}>
															<h6>What activities or organizations will you participate in?</h6>
														</Col>
														<Col xs={12} md={9}>
															<Input
																type="textarea"
																rows={3}
																value={goal.goaltype || ''}
																onChange={(e) => onGoalUpdate(goalType, index, 'goaltype', e.target.value)}
															/>
														</Col>
													</Row>
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<Row className="d-flex align-items-center">
														<Col xs={12} md={3}>
															<h6>How did your skill level change / advance?</h6>
														</Col>
														<Col xs={12} md={9}>
															<Input
																type="textarea"
																rows={3}
																value={goal.goalcontact || ''}
																onChange={(e) => onGoalUpdate(goalType, index, 'goalcontact', e.target.value)}
															/>
														</Col>
													</Row>
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<Row className="d-flex align-items-center">
														<Col xs={12} md={3}>
															<h6>Validator</h6>
														</Col>
														<Col xs={12} md={9}>
															<Input
																type="text"
																value={goal.validator || ''}
																onChange={(e) => onGoalUpdate(goalType, index, 'validator', e.target.value)}
															/>
														</Col>
													</Row>
												</td>
											</tr>
										</tbody>
									</Table>
								</Form>

								<Form>
									<Table bordered hover>
										<thead>
											<tr>
												<th>Date</th>
												<th>Hour</th>
												<th>Notes</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody>
											{goal?.activities?.map((activity, idx) => (
												<tr key={idx}>
													<td style={{ width: '15%' }}>
														<Input
															type="date"
															value={activity.fdate || ''}
															onChange={(e) => onActivityUpdate(goalType, index, idx, 'fdate', e.target.value)}
														/>
													</td>
													<td style={{ width: '10%' }}>
														<Input
															type="number"
															value={activity.fhour || ''}
															onChange={(e) => onActivityUpdate(goalType, index, idx, 'fhour', e.target.value)}
														/>
													</td>
													<td style={{ width: '55%' }}>
														<Input
															type="textarea"
															rows={2}
															value={activity.fnotes || ''}
															onChange={(e) => onActivityUpdate(goalType, index, idx, 'fnotes', e.target.value)}
														/>
													</td>
													<td style={{ width: '10%' }}>
														<Button color="danger" size="sm" onClick={() => onRemoveActivity(goalType, index, idx, activity.id)}>
															Remove
														</Button>
													</td>
												</tr>
											))}
										</tbody>
									</Table>
									<div className="d-flex justify-content-between">
										<Button color="primary" className="m-1" onClick={() => onAddActivity(goalType, index)}>
											Add Activity
										</Button>
									</div>
								</Form>
							</CardBody>
						</Collapse>
					</Card>
				))}
			</Col>
			<Col
				xs={12}
				md={3}
				style={{
					position: 'sticky',
					height: '100vh',
					top: '150px',
					overflowY: 'auto',
					backgroundColor: '#f8f9fa',
					padding: '15px'
				}}
			>
				<div>
					<h6>Examples:</h6>
					<ul>
						{getExamplesList(goalType).map((example, idx) => (
							<li key={idx}>{example}</li>
						))}
					</ul>
				</div>
			</Col>
		</Row>
	)
}

export { GoalAccordion }
